export const GET_LOAN_ROLLOVER_SPLITS = 'loan_rollover_splits/GET_LOAN_ROLLOVER_SPLITS'
export const ADD_LOAN_ROLLOVER_SPLIT = 'loan_rollover_splits/ADD_LOAN_ROLLOVER_SPLIT'
export const EDIT_LOAN_ROLLOVER_SPLIT = 'loan_rollover_splits/EDIT_LOAN_ROLLOVER_SPLIT'
export const SUBMIT_LOAN_ROLLOVER_SPLIT = 'loan_rollover_splits/SUBMIT_LOAN_ROLLOVER_SPLIT'
export const APPROVE_LOAN_ROLLOVER_SPLIT = 'loan_rollover_splits/APPROVE_LOAN_ROLLOVER_SPLIT'
export const REJECT_LOAN_ROLLOVER_SPLIT = 'loan_rollover_splits/REJECT_LOAN_ROLLOVER_SPLIT'
export const GET_APPROVED_LOAN_ROLLOVER_SPLITS =
  'loan_rollover_splits/GET_APPROVED_LOAN_ROLLOVER_SPLITS'
export const DELETE_LOAN_ROLLOVER_SPLIT = 'loan_rollover_splits/DELETE_LOAN_ROLLOVER_SPLIT'
export const START_LOADING_LOAN_ROLLOVER_SPLIT =
  'loan_rollover_splits/START_LOADING_LOAN_ROLLOVER_SPLIT'
export const STOP_LOADING_LOAN_ROLLOVER_SPLIT =
  'loan_rollover_splits/STOP_LOADING_LOAN_ROLLOVER_SPLIT'
